import React from 'react';
import {
    EventAdmin as EventAdminView,
    EventAdminCreate as EventAdminCreateView,
    EventAdminDetail as EventAdminDetailView,
    UserListAdmin as UserListAdminView,
    UserUpload as UserUploadView,
    WorkshopAdmin as WorkshopAdminView,
    WorkshopListAdmin as WorkshopListAdminView,
} from 'views/DashboardAdmin';

import { InvoiceEdit as InvoiceEditView } from 'views/DashboardOperator';

const routes = [
    // {
    //   path: '/dashboard/admin/event',
    //   element: <EventAdminView />
    // },
    // {
    //   path: '/dashboard/admin/create-event',
    //   element: <EventAdminCreateView />
    // },
    // {
    //   path: '/dashboard/admin/detail-event/:id',
    //   element: <EventAdminDetailView />
    // },
    {
        path: '/dashboard/admin/user-list',
        element: <UserListAdminView />,
    },
    {
        path: '/dashboard/admin/user-upload',
        element: <UserUploadView />,
    },
    {
        path: '/dashboard/admin/invoice/:id',
        element: <InvoiceEditView />,
    },
    {
        path: '/dashboard/admin/workshop',
        element: <WorkshopAdminView />,
    },
    {
        path: '/dashboard/admin/workshop-list',
        element: <WorkshopListAdminView />,
    },
];

export default routes;
